import { Addon as MarketplaceAddon } from '@galaxy/marketplace-apps/v1';
import { App as MarketplaceApp } from '@vendasta/marketplace-apps';
import { Package as MarketplacePackage } from '@vendasta/marketplace-packages';
import { GenericResellerItem, fromResellerItem } from './store';
import { fromMarketplaceAddon, fromMarketplaceApp, fromMarketplacePackage } from './marketplace';
import { InventoryItem } from '../type';

export type InventoryItemAdapter = MarketplaceApp | MarketplaceAddon | MarketplacePackage | GenericResellerItem;

export function ToInventoryItem<T extends InventoryItemAdapter>(item: T): InventoryItem {
  if (isMarketplaceApp(item)) {
    return fromMarketplaceApp(item);
  }

  if (isMarketplaceAddon(item)) {
    return fromMarketplaceAddon(item);
  }

  if (isMarketplacePackage(item)) {
    return fromMarketplacePackage(item);
  }

  if (isResellerItem(item)) {
    return fromResellerItem(item);
  }

  throw new Error('ToInventoryItem error - missing adapter for item:' + item);
}

export function isMarketplaceApp(item: InventoryItemAdapter): item is MarketplaceApp {
  return item instanceof MarketplaceApp;
}

export function isMarketplaceAddon(item: InventoryItemAdapter): item is MarketplaceAddon {
  return item instanceof MarketplaceAddon;
}

export function isMarketplacePackage(item: InventoryItemAdapter): item is MarketplacePackage {
  return item instanceof MarketplacePackage;
}

export function isResellerItem(item: InventoryItemAdapter): item is GenericResellerItem {
  return item instanceof GenericResellerItem;
}
